import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MN_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#MN_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 0h12v24H10V0z",
      fill: "#4C67E8"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 0h10v24H22V0zM0 0h12v24H0V0z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.013 6.884c-1.013 0-.88-.987-.88-.987l.48-1.038v1.038c0 .133.182-.134.182-.455 0-.322.218-.803.218-.803s.009-.16.015-.32c.035.082.104.153.21.26l.06.06c.125.129.108.469.093.763-.013.266-.025.495.073.495.206 0 .19-.92.19-.92l.346.92s.026.987-.987.987zm0-2.82c.026-.15.022.05.015.256a.435.435 0 01-.015-.256zm1.526 4.62c0 .802-.672 1.453-1.5 1.453s-1.5-.65-1.5-1.453.672-1.454 1.5-1.454 1.5.65 1.5 1.454zm-3.77 2.72H2v8.571h1.77v-8.571zm6.23 0H8.23v8.571H10v-8.571zm-5.769.074l1.725 1.068L7.9 11.478H4.23zM5.955 20L4.23 18.931H7.9L5.954 20zM4.23 12.894h3.616v.671H4.23v-.67zm3.616 4.994H4.23v.671h3.616v-.67zm-1.77-.372c1.02 0 1.847-.801 1.847-1.789 0-.988-.827-1.789-1.846-1.789-1.02 0-1.847.801-1.847 1.789 0 .988.827 1.789 1.847 1.789zm-2.072-8.3s.062 1.867 1.903 1.867c1.84 0 2.137-1.867 2.137-1.867s-.712 1.143-2.02 1.143-2.02-1.143-2.02-1.143z",
      fill: "#F8D000"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.358 13.972l.082-.367c.413.45.6.704.511 1.117-.098.462-.616.976-1.218 1.4-.365.256-.588.948-.407 1.169l-.173.314c-.403-.491-.08-1.417.476-1.808.51-.36.867-.737.93-1.034.04-.193.116-.444-.201-.791z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.5 17a.5.5 0 100-1 .5.5 0 000 1zM5.375 15.65a.5.5 0 100-1 .5.5 0 000 1z",
      fill: "#C51918"
    }
  ))
), a = t;
export {
  a as default
};
